// src/components/pageBuilder/components/ContactCard.tsx
"use client";

import React from "react";
import SafeHtml from "@/components/ui/SafeHtml";
import { useLayoutData } from "@/components/layout/LayoutDataProvider";
import { PhoneIcon, EmailIcon } from "@/components/ui/Icons";
import type { ContactCardFields } from "@/types/acf";

type CompanyData = {
  phone?: string;
  email?: string;
};

export default function ContactCard({ data }: { data: ContactCardFields }) {
  const { company_data } = useLayoutData() as { company_data?: CompanyData };
  const title = data?.title ?? "";
  const subtitle = data?.subtitle ?? "";

  const phone = company_data?.phone ?? "";
  const email = company_data?.email ?? "";

  return (
    <div className="bg-fuji-grey py-10">
      <div className="px-4 md:px-8">
        {/* Title */}
        {title && (
          <div className="text-title-2 mb-2 font-semibold">
            <SafeHtml content={title} />
          </div>
        )}

        {/* Row */}
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          {/* Subtitle */}
          {subtitle && (
            <div className="font-semibold">
              <SafeHtml content={subtitle} flow />
            </div>
          )}

          {/* Phone */}
          {phone && (
            <a
              href={`tel:${String(phone).replace(/[^\d+]/g, "")}`}
              className="flex items-center gap-3 text-body no-underline hover:underline"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-black text-fuji-black">
                <PhoneIcon className="text-black" fill="fill-fuji-black" />
              </span>
              <span className="text-black font-semibold">{phone}</span>
            </a>
          )}

          {/* Email */}
          {email && (
            <a
              href={`mailto:${email}`}
              className="flex items-center gap-3 text-body no-underline hover:underline"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-black">
                <EmailIcon className="text-black" />
              </span>
              <span className="text-black font-semibold">{email}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
